import axios from "../axios";

//登录 POST /as-web/api/v1/auth/login（兼容旧调用，推荐使用 $api.auth.login）
export const login = (data) => {
    return axios({
        //url: "auth/login",
        method: "post",
        data
    })
}

//查询状态名称
// 0项目作业状态，1机器人作业状态,
export const getWorkStatusName = (data) => {
    
    return axios({
        url: "common/query_work_status_name",
        method: "post",
        data
    })
}

//查询角色类型列表
export const getRoleList = (data) => {
   
    return axios({
        url: "common/query_role_list",
        method: "post",
        data
    })
}
//获取领域列表
export const getDoMainList = (data)=>{
   
    return axios({
        url: "common/query_domain_list",
        method: "post",
        data
    })
}
